import { getDirectoryLink } from "../utilities/getDirectoryLink";
import { getGroupPageLink } from "../utilities/getGroupPageLink";
import { getGroupName } from "./getGroupName";
import { initSearch } from "./initSearch";
export function listGroups(deacons) {
    const deaconsContainer = document.querySelector(".deacons-container");
    let html = '<ul class="deacons">';
    initSearch(deacons);
    if (deacons.length) {
        deacons.forEach((deacon) => {
            var _a;
            const groupName = getGroupName(deacon);
            const familyName = deacon["family-name"];
            const name = deacon["first-name"] + " " + deacon["last-name"];
            const email = (deacon === null || deacon === void 0 ? void 0 : deacon.email) || "";
            const phone = (deacon === null || deacon === void 0 ? void 0 : deacon.cell) || "";
            html += `
                <li class="deacon">
                    <div class="deacon-image">
                        <img src="${deacon["individual-photo-url"] || "https://www.cedarparkchurchofchrist.org/media/frontend/members/no-image.jpg"}" alt="Photo of ${deacon["first-name"]} ${deacon["last-name"]}" />
                    </div>
                    <div class="deacon-main">
                        <h4>
                            <a href="${getDirectoryLink(deacon["family-id"], familyName)}">${name}</a>
                        </h4>
                        <ul class="deacon-duties">
            `;
            // TODO: markdown
            (_a = deacon["serves-in"]) === null || _a === void 0 ? void 0 : _a.split("\n").forEach((service) => {
                html += `<li>${service}</li>`;
            });
            html += `
                        </ul>
                    </div>
                    <aside class="deacon-contact">
                        <ul>
                            <li class="group-name">
                                <i class="fa-solid fa-people-group"></i>
                                <a href="${getGroupPageLink(groupName)}">${groupName}</a>
                            </li>
                            <li>
                                <i class="fa-solid fa-phone" aria-hidden="true"></i>
                                <a href="tel:${phone.replace(/\D/g, "")}" title="${phone}">${phone}</a>
                            </li>
                            <li>
                                <i class="fa-solid fa-envelope" aria-hidden="true"></i>
                                <a href="mailto:${email}" title="${email}">${email}</a>
                            </li>
                            <li>
                                <i class="fa-solid fa-address-book" aria-hidden="true"></i>
                                <a href="${getDirectoryLink(deacon["family-id"], familyName)}">Open directory listing</a>
                            </li>
                        </ul>
                    </aside>
                </li>
            `;
        });
        deaconsContainer.innerHTML = html + "</ul>";
    }
    else {
        deaconsContainer.innerHTML = "<p>Sorry, we couldn't find a match.</p>";
    }
}
